import PropTypes from "prop-types"

import _ from "lodash"

import React, { useEffect, useState, useMemo, useRef} from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams  } from "react-router-dom"

import { Formik, Field, ErrorMessage, FieldArray, useFormik } from "formik"

import withRouter from "components/Common/withRouter"

import { getSession, setSession, getCurrentUser } from "helpers/AuthType/authService"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import valadiation Schemas
import { getPersonalInfomationValidationSchema } from "common/validation-schema"
import {
    applicationResetState,
    applicationPersonalInformation,
    applicationUpdateAddress,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import {
  findElementPositionById,
  regexp,
  showPreloader,
  hidePreloader,
} from "common/global/functions.js"

import PersonalInformationForm from "./forms/personalInformationForm"

const PersonalInformation = props => {
  //meta title
  document.title = "Applicant Information | Equity Sales Finance, INC."

  const dispatch = useDispatch()

  const params =  useParams();

  let {
    app,
    merchant,
    pagetracker,
  } = getSession();

  const applicantType = props.state.applicantType;

  if(applicantType == 'coapplicant'){
    let {_applicant : applicant} = getCurrentUser();
  }

  var path =
    applicantType == "coapplicant"
      ? "/co/income-information"
      : "/income-information"

  let schema = getPersonalInfomationValidationSchema(applicantType)
  const formRef = useRef()

  const selectApplicationState = state => state.application
  const ApplicationProperties = createSelector(
    selectApplicationState,
    application => ({
      addressVerification: application.addressVerification,
      error: application.error,
      loading: application.loading,
      response: application.response,
    })
  )

  const { error,  loading, response, addressVerification, } = useSelector(
    ApplicationProperties
  )

  const [activeTab, setactiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])  
  const [submitted, setSubmitted] = useState(false) 
  const [addressElements, setAddressElements] = useState(false) 
  const [addressMatch, setAddressMatch] = useState(false) 
  const [dpvConfirmation, setDpvConfirmation] = useState(false) 
  const [formatted, setFormatted] = useState(false) 
  const [formattedAddress, setFormattedAddress] = useState(false)
  const [requestedAddress, setRequestedAddress] = useState(false) 
  const [requested, setRequested] = useState(false)  
  const [components, setComponents] = useState(false)  
  const [addressModal, setAddressModal] = useState(false)
  const [addressRadioBtn, setAddressRadioBtn] = useState(1)
  

  const handleFormSubmit = async () => {    
    formRef.current.handleSubmit()
    if(!formRef.current.errors)
      setAddressElements(false)
  }

  useEffect(() => {
    if (error) {
      try {
        window.scroll({top: 0,left: 0,behavior: "smooth",})
      } catch (error) {
        window.scrollTo(0, 0)
      }
    }
  }, [error])

  useEffect(() => {
    if(loading)
      setSubmitted(true)
  }, [loading])

  useEffect(() => {
    if(submitted && !loading){   
      setSubmitted(false)
      if(response){
        setAddressElements(response)
        setDpvConfirmation(_.has(response,'dpvConfirmation') ? response.dpvConfirmation : false)
        setFormatted(_.has(response,'formatted') ? response.formatted : false)
        setFormattedAddress(_.has(response,'formattedAddress') ? response.formattedAddress : false)
        setRequestedAddress(_.has(response,'requestedAddress') ? response.requestedAddress : false)
        setRequested(_.has(response,'requested') ? response.requested : false)
        setComponents(_.has(response,'components') ? response.components : false)
        setAddressMatch(response.addressMatch)
      }      
    }    
  }, [response])

  useEffect(() => {
    if(addressElements && !addressMatch){
      setAddressModal(true)
    }      
  }, [addressElements])

  const onAddressRadioBtnChange = event => {
    setAddressRadioBtn(_.toInteger(event.target.value))
  }

  const onAddressSubmit = event => {
    dispatch(applicationUpdateAddress(applicantType, addressRadioBtn ? formatted : requested, props.router.navigate))
  }

  return (
    <React.Fragment>

      {/* Address Modal */}
      <Modal
        size="lg"
        isOpen={addressModal}
        toggle={() => {
          setAddressModal(!addressModal)
        }}
        backdrop={"static"}
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Address Verification
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setAddressModal(!addressModal)
            }}
            aria-label="Close"
          ></button>
        </div>

        {error ? <Alert color="danger">{error}</Alert> : null}

        {!addressMatch && dpvConfirmation && formattedAddress  ? (
          <>
            <div className="modal-body">
              <h5 className="font-size-14 mb-4">
                Review the recommended changes
              </h5>

              <Row>
                <Col xl={12} sm={12}>
                  <div className="mt-1">
                    <div className="form-check mb-3 p-3">
                      <h5 className="font-size-13 mb-4">
                        <strong>
                          <u>What you entered</u>
                        </strong>
                      </h5>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="addr_verification"
                        id="addr_verification2"
                        value={0}
                        onChange={onAddressRadioBtnChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="addr_verification2"
                      >
                        <span>{requestedAddress}</span>
                        <br />
                      </label>
                    </div>

                    <div className="form-check mb-3">
                      <h5 className="font-size-13 mb-4">
                        <strong>
                          <u>Recommended</u>
                        </strong>
                      </h5>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="addr_verification"
                        id="addr_verification1"
                        value={1}
                        onChange={onAddressRadioBtnChange}
                        defaultChecked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="addr_verification1"
                      >
                        <span>{formattedAddress}</span>
                        <br />
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={event => {
                  onAddressSubmit(event)
                }}
              >
                Update
              </button>
            </div>
          </>
        )  : !addressMatch && !dpvConfirmation && components ? (
          <>
            <div className="modal-body">
              <Row>
                <Col xl={12} sm={12}>
                  <div className="mt-1">
                    <h5 className="font-size-14 mb-4">
                      <strong className="text-danger">
                        Review address validation issues.{" "}
                      </strong>
                    </h5>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={12} sm={12}>
                  <div className="mt-1">
                    <h5 className="font-size-14 mb-4">
                      <strong>
                        <u>What you entered</u>
                      </strong>
                    </h5>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={12} sm={12}>
                  <div className="mt-1">
                    <h5 className="font-size-13 mb-4">
                    <span>{requestedAddress}</span>
                    </h5>
                  </div>
                </Col>
              </Row>
              <br />
              <Row>
                <Col xl={12} sm={12}>
                  <div className="mt-1">
                    <h5 className="font-size-14 mb-4">
                      <strong>
                        <u>Found Issues</u>
                      </strong>
                    </h5>
                  </div>
                  {_.map(components, (component, key) => (
                    <div key={crypto.randomUUID()}>
                      {!_.isEmpty(component) ? (
                        <div key={crypto.randomUUID()}>
                          {_.map(component, (value, componentType) => (
                            <Alert key={crypto.randomUUID()} color="warning">
                              {`missing or unconfirmed ${componentType}: `}
                              <strong>{value}</strong>
                            </Alert>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  ))}
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setAddressModal(!addressModal)
                }}
              >
                Make Changes
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddressModal(!addressModal)
                  props.router.navigate(path)
                }}
              >
                Use Entered
              </button>
            </div>
          </>
        ) : !addressMatch && !dpvConfirmation && (
          <>
            <div className="modal-body">
              <strong className="text-danger">
                We are unable to verify the address provided.{" "}
              </strong>
              <br />
              <br />
              <strong>
                <span>{requestedAddress}</span>
              </strong>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setAddressModal(!addressModal)
                }}
              >
                Correct Address
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddressModal(!addressModal)
                  props.router.navigate(path)
                }}
              >
                Keep As Is
              </button>
            </div>
          </>
        ) }
      </Modal>
      {/* Address Modal */}

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={
              applicantType == "coapplicant"
                ? "Co-Signer"
                : "Applicant"
            }
            breadcrumbItem={"Personal Information"}
          />
          {error ? <Alert color="danger">{error}</Alert> : null}

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4"></CardTitle>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">1.</span> Personal
                            Information
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="number">2.</span> Income
                            Information
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="number">3.</span> Residency
                            Information
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                            disabled={!(passedSteps || []).includes(4)}
                          >
                            <span className="number">4.</span> References
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>

                          <Formik
                            enableReinitialize={true}
                            innerRef={formRef}
                            initialValues={
                              schema.initialValues
                            }
                            validationSchema={
                              schema.validationSchema
                            }
                            onSubmit={async values => {
                              try {
                                dispatch(applicationPersonalInformation(values, props.router.navigate))
                              } catch (error) {
                                console.error({ error })
                              }
                            }}
                            component={PersonalInformationForm}
                          />

                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            loading
                              ? "previous disabled"
                              : "previous"
                          }
                        >
                          {/* <Link
                            to={"#"}
                            className="btn btn-info btn-block"
                            onClick={e => onPreviousBtnClick(e)}
                          >
                            Previous
                          </Link> */}
                        </li>

                        <li className={loading ? "next disabled" : "next"}>
                          <Link
                            to="#"
                            onClick={e => {
                              handleFormSubmit()
                              e.preventDefault()
                            }}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm">Loading...</Spinner>
                                <span> Loading</span>
                              </>
                            ) : (
                              "Next"
                            )}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(PersonalInformation)

PersonalInformation.propTypes = {
  history: PropTypes.object,
}
